import React from "react";

const SimContainer = ({ children, fluid, className = "" }) => {
  const containerClass = fluid ? "container-fluid" : "container";

  return <div className={`${containerClass} ${className}`}>{children}</div>;
};

export default SimContainer;
